var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _dec7, _dec8, _class2, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait from "../../Decorators/objectArrayTrait";
import primitiveTrait from "../../Decorators/primitiveTrait";
import ModelTraits from "../../ModelTraits";
export let TableChartLineStyleTraits = (_dec = primitiveTrait({
  name: "Name",
  description: "Chart line name (will replace y-column name).",
  type: "string"
}), _dec2 = primitiveTrait({
  name: "Y Axis Column",
  description: "The column to use as the Y-axis.",
  type: "string"
}), _dec3 = primitiveTrait({
  name: "Y Axis Minimum",
  description: "The minimum value to show on the Y axis of the chart.",
  type: "number"
}), _dec4 = primitiveTrait({
  name: "Y Axis Maximum",
  description: "The maximum value to show on the Y axis of the chart.",
  type: "number"
}), _dec5 = primitiveTrait({
  name: "Color",
  description: "The color of the line. If not specified, a unique color will be assigned automatically.",
  type: "string"
}), _dec6 = primitiveTrait({
  name: "Is selected in workbench?",
  description: "The selection state of the line in the workbench.",
  type: "boolean"
}), _class = class TableChartLineStyleTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "name", _descriptor, this);
    _initializerDefineProperty(this, "yAxisColumn", _descriptor2, this);
    _initializerDefineProperty(this, "yAxisMinimum", _descriptor3, this);
    _initializerDefineProperty(this, "yAxisMaximum", _descriptor4, this);
    _initializerDefineProperty(this, "color", _descriptor5, this);
    _initializerDefineProperty(this, "isSelectedInWorkbench", _descriptor6, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "name", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "yAxisColumn", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "yAxisMinimum", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "yAxisMaximum", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "color", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "isSelectedInWorkbench", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _class);
let TableChartStyleTraits = (_dec7 = primitiveTrait({
  name: "X Axis Column",
  description: "The column to use as the X-axis.",
  type: "string"
}), _dec8 = objectArrayTrait({
  name: "Lines",
  description: "Lines on the chart, each of which is formed by plotting a column as the Y-axis.",
  type: TableChartLineStyleTraits,
  idProperty: "yAxisColumn"
}), _class2 = class TableChartStyleTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "xAxisColumn", _descriptor7, this);
    _initializerDefineProperty(this, "lines", _descriptor8, this);
  }
}, _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "xAxisColumn", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor8 = _applyDecoratedDescriptor(_class2.prototype, "lines", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
export { TableChartStyleTraits as default };